import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirplane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAirplane"><Path d="M16.6023 3.70324L13.5833 6.72222L4.61111 3.55556L2.5 5.66667L9.36111 10.9444L7.25 13.0556H5.13889L2.5 15.6944L6.72222 17.2778L8.30556 21.5L10.9444 18.8611V16.75L13.0556 14.6389L18.3333 21.5L20.4444 19.3889L17.2778 10.4167L20.2968 7.39768C21.0672 6.62726 21.5 5.58235 21.5 4.49281V2.5H19.5072C18.4177 2.5 17.3727 2.93282 16.6023 3.70324Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconAirplane;
